import { Label, LabelColor } from '@shared/components';

export type ProctorTypeLabelVariant = 'proctor-1' | 'proctor-2' | 'proctor-3';

interface ProctorTypeLabelProps {
  variant: ProctorTypeLabelVariant;
}

const PROCTOR_TYPE_TEXT: Readonly<Record<ProctorTypeLabelVariant, string>> = {
  'proctor-1': 'ผู้คุมสอบประเภทที่ 1',
  'proctor-2': 'ผู้คุมสอบประเภทที่ 2',
  'proctor-3': 'ผู้คุมสอบประเภทที่ 3',
};

export default function ProctorTypeLabel(props: Readonly<ProctorTypeLabelProps>) {
  const { variant } = props;

  return (
    <Label
      sx={(theme) => ({
        px: theme.spacing(2.5),
        borderRadius: theme.shape.rounded(7),
      })}
      color={LabelColor.GREY}
      variant='outlined'
    >
      {PROCTOR_TYPE_TEXT[variant]}
    </Label>
  );
}
